export function logosSlider() {
    const $window = $(window);
    $window.on("load", function () {
        $(".logos-slider").each(function () {
            let $this = $(this);
            $this.infiniteslide({
                direction: "left",
                speed: 30,
                pauseonhover: false,
                clone: 2
            });
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/logosSlider.js